package com.schoolconnect.app.state

import com.schoolconnect.app.navigation.FeatureRoute
import com.schoolconnect.app.navigation.HomeRoute
import com.schoolconnect.app.feature.rolepicker.RolePickerUiState

data class AppUiState(
    val isDarkTheme: Boolean = false,
    val currentRoute: Any = FeatureRoute("splash"),
    val isAuthenticated: Boolean = false,
    val isBootstrapping: Boolean = true,
    val isLoggingOut: Boolean = false,
    val currentUserId: String = "",
    val activeAssignmentId: String = "",
    val homeRoleCode: String = "",
    val homeRoleSchoolId: String = "",
    val homeRoleSchoolLabel: String = "",
    val homeRoleSchoolCode: String = "",
    val restoredRailId: String = "dashboard",
    val feedbackMessage: String = "",
    val feedbackNonce: Int = 0,
    val startupRolePicker: RolePickerUiState = RolePickerUiState()
)

fun AppUiState.currentFeatureId(): String? = (currentRoute as? FeatureRoute)?.featureId
